import * as store from './store.ts';

export { store };
